export default {
  computed: {
    height() {
      return Math.round(this.width / 1.777);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/CalcHeightMixin.js